import { WhizWidget } from "./WhizWidget";

export interface MessageMetadata {
    metadata?: {};
    timestamp?: number;
}

export interface UserMessage extends MessageMetadata {
    message: string;
    widgets?: WhizWidget[];
}

export enum SystemMessageType {
    SET_DATA = "SET_DATA",
    START_SESSION = "START_SESSION",
    RESTART_SESSION = "RESTART_SESSION",
    TYPING_INDICATOR = "application/x.whiz.typing-indicator",
    MESSAGE_PREVIEW = "application/x.whiz.message-preview",
    JOIN_REQUEST = "application/x.whiz.join-request",
    JOIN_RESPONSE = "application/x.whiz.join-response",
    ADD_PHONE_NUMBER = "application/x.whiz.add-phone-number",
    START_OPT_IN = "application/x.whiz.start-opt-in",
    VIDEO_REQUEST_FROM_USER = "application/x.whiz.video-request-user",
    VIDEO_RESPONSE_FROM_USER = "application/x.whiz.video-response-user",
    VIDEO_REQUEST_FROM_DEALER = "application/x.whiz.video-request-dealer",
    VIDEO_RESPONSE_FROM_DEALER = "application/x.whiz.video-response-dealer",
}

export interface SystemMessage extends MessageMetadata {
    message?: { [key: string]: any };
    messageType: SystemMessageType;
}

export interface OutboundMessage extends MessageMetadata {
    message: string;
    sessionId: string;
    messageId: string;
    widgets?: WhizWidget[];
}
